import React, { useState, useEffect, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API_BASE_CRM_URL } from "../../Config/Config";
import Pagination from "../../Config/Pagination";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Base from "../../Config/Base";
import PDFIMG from "../../Config/pdf.svg";
import EXCELIMG from "../../Config/excel.svg";
import Swal from "sweetalert2";
import { useLabelContext } from "../../../Context";
import UploadTasksByExcel from "./UploadTaskByExcel";
import { Footer } from "../footer/footer";

const Tasks = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [tasksData, setTasksData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  // const [selectedTaskId, setSelectedTaskId] = useState(null);
  const { setID } = useLabelContext();

  const userDetails = JSON.parse(sessionStorage.getItem("userDetails") || "{}");
  const userId = userDetails?.staffid;

  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");
    if (!userDetails) {
      navigate("/");
    }
  }, [navigate]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${API_BASE_CRM_URL}tasks/GetTasksnew?assigned=${userId}&status=0`,
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();

      if (data.Status) {
        setTasksData(data.ResultData);
        // console.log(data.ResultData);
      } else {
        console.error("Fetched data is not an array:", data);
        setTasksData([]);
      }
    } catch (error) {
      console.error("Error fetching datasssss:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // const filteredItems = tasksData.filter(
  //   (item) =>
  //     (item.name && item.name.toString().includes(searchTerm.toString())) ||

  //     (item.priority &&
  //       item.priority.toLowerCase().includes(searchTerm.toLowerCase()))
  // );

  const filteredItems = useMemo(() => {
    const results = tasksData.filter(
      (item) =>
        item.name && item.name.toString().includes(searchTerm.toString()),
    );

    setCurrentPage(1);

    return results;
  }, [tasksData, searchTerm]);

  // Calculate indices for slicing data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
  // const [expandedDescriptions, setExpandedDescriptions] = useState({});

  const [expandedTasks, setExpandedTasks] = useState({});
  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const handleReload = () => {
    window.location.reload();
  };

  const handleExcelDownload = () => {
    if (tasksData.length === 0) {
      return; // Don't download if there is no data
    }

    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Convert your data to worksheet format
    const wsData = tasksData.map((item) => ({
      Name: item.name,

      "Start Date": formatDate(item.startdate),
      "Due Date": formatDate(item.duedate),
      "Assigned To": item.staff_names,
      Tags: item.tag_name,
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "tasksData");

    // Save the workbook to a file
    XLSX.writeFile(wb, "tasksData.xlsx");
  };

  const handlePDFDownload = () => {
    const doc = new jsPDF();

    // Set properties for PDF
    doc.setProperties({
      title: "Tasks",
      author: "Your Name",
      creator: "Your Application",
    });

    // Add data to PDF
    const tableData = []; // Your data array here

    // Add a header row
    const headers = ["Name", "Start Date", "Due Date", "Assigned to", "Tags"];
    tableData.push(headers);

    // Add rows
    tasksData.forEach((item) => {
      const row = [];
      row.push(
        item.name,
        formatDate(item.startdate),
        formatDate(item.duedate),
        item.staff_names,
        item.tag_name,
      );
      tableData.push(row);
    });

    // Generate table
    doc.autoTable({
      head: [headers],
      body: tableData.slice(1),
    });

    // Save the PDF
    doc.save("tasksData.pdf");
  };

  const handleViewPurchaseOrders = (item) => {
    console.log(item);
    setID(item.id);
  };

  const handledelete = async (item) => {
    console.log(item);
    try {
      const response = await fetch(`${API_BASE_CRM_URL}DeleteTask`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ Id: item.id }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      console.log(result);
      if (result.Status) {
        setLoading(false);
        Swal.fire({
          title: `Task Deleted Successfully`,
          icon: "success",
          customClass: {
            title: "swal-title",
            content: "swal-text",
          },
        }).then((result) => {
          if (result.isConfirmed || result.isDismissed) {
            // window.location.reload();
            fetchData();
          }
        });
      } else {
        setLoading(false);
        Swal.fire({
          title: "Error",
          text: "Failed to submit request.",
          icon: "error",
          customClass: {
            title: "swal-title",
            content: "swal-text",
          },
        });
      }
    } catch (error) {
      setLoading(false);
      console.error("Error:", error);
    }
  };

  return (
    <Base>
      <div className="">
        <div className="d-flex justify-content-between">
          <div className="page-title">
            <h4>Tasks</h4>
            <h6>Manage your Tasks here</h6>
          </div>
          <div>
            {/* PDF & Excel - Far Right */}
            <ul className="d-inline-flex list-unstyled gap-1 mb-0 justify-content-end">
              <li className="">
                <a
                  href="#"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="PDF"
                  onClick={(e) => {
                    e.preventDefault();
                    handlePDFDownload();
                  }}
                  className="btn btn-light btn-sm px-0"
                >
                  <i
                    className="fa-solid fa-file-pdf fa-2xl"
                    style={{ color: "#ff0000" }}
                  ></i>
                </a>
              </li>

              <li className="p-0 m-0">
                <a
                  href="#"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Excel"
                  onClick={(e) => {
                    e.preventDefault();
                    handleExcelDownload();
                  }}
                  className="btn btn-light btn-sm "
                >
                  {/* <img src="assets/img/icons/excel.svg" alt="Excel" /> */}
                  <i
                    className="fa-solid fa-file-excel fa-2xl"
                    style={{ color: "#217346" }}
                  ></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-12 mb-2 mt-2">
          <div className="input-group">
            <input
              type="text"
              name="search"
              placeholder="Search..."
              className="form-control"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <span className="input-group-text bg-primary" id="basic-addon1">
              <i className="fa-solid fa-magnifying-glass"></i>
            </span>
          </div>
        </div>
      </div>

      <div className="card-container">
        {loading ? (
          <div className="containers m-auto">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        ) : (
          <div className="row g-2">
            {currentItems &&
              currentItems.map((item, index) => (
                <div key={index} className="col-12 col-md-6 col-lg-4">
                  <div
                    className="card shadow-sm h-100"
                    style={{
                      borderRadius: "10px",
                      border: "1px solid #f1f1f1",
                    }}
                  >
                    <div className="card-body pb-0">
                      {/* Header */}
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <div>
                          <h6 className="mb-1 fw-bold">{item.name}</h6>
                        </div>

                        {/* Action Menu */}
                        <div className="dropdown d-none">
                          <a
                            className="text-dark"
                            href="#"
                            data-bs-toggle="dropdown"
                          >
                            <i className="fa fa-ellipsis-v"></i>
                          </a>

                          <div className="dropdown-menu">
                            <Link
                              to={`/view-task`}
                              state={{ task: item }}
                              className="dropdown-item"
                              onClick={() => handleViewPurchaseOrders(item)}
                            >
                              <i className="fa-regular text-info fa-eye me-2"></i>
                              View
                            </Link>

                            {/* <Link
                              to="/view-task"
                              className="me-2 p-2 shadow-sm"
                              // onClick={(event) => {
                              //   event.preventDefault();
                              //   setSelectedTaskId(record.id);
                              //   setFilesDrawerOpen(true);
                              // }}
                              onClick={(event) => {
                                event.preventDefault();

                                handleViewPurchaseOrders(item);

                                // setSelectedTaskId(record.id);
                              }}
                              title="View Attachments"
                            >
                              <i className="ti ti-paperclip text-success"></i>
                            </Link> */}

                            {/* <Link
                              className="dropdown-item"
                              to={`/edit-task`}
                              onClick={() => handleViewPurchaseOrders(item)}
                            >
                              <i className="fa-regular fa-pen-to-square text-info me-2"></i>
                              Edit
                            </Link>

                            <a
                              className={`dropdown-item ${
                                item.status === 1 ? "" : "disabled"
                              }`}
                              onClick={() => handledelete(item)}
                            >
                              <i className="fa-regular fa-trash-can text-danger me-2"></i>
                              Delete
                            </a> */}
                          </div>
                        </div>
                      </div>

                      {/* Details */}
                      <div className="row g-2">
                        <div className="col-6">
                          <small className=" d-block">
                            <i className="fa-solid fa-user me-1 text-success"></i>

                            <strong>
                              {item.relatedName?.length > 25
                                ? `${item.relatedName.slice(0, 25)}...`
                                : item.relatedName}
                            </strong>
                          </small>
                        </div>
                        <div className="col-3">
                          <small className=" d-block">
                            <i className="fa-solid fa-calendar-days me-1 text-info"></i>

                            <strong>{formatDate(item.startdate)}</strong>
                          </small>
                        </div>

                        <div className="col-3">
                          <small className=" d-block">
                            <i className="fa-solid fa-calendar-check me-1 text-danger"></i>
                            <strong>{formatDate(item.duedate)}</strong>
                          </small>
                        </div>

                        {/* <div className="col-4">
                          <small className="text-muted d-block mb-1">
                            <i className="fa-solid fa-user-group me-1 text-success"></i>
                            Assigned To
                          </small>

                          <div className="d-flex flex-wrap gap-1">
                            {item.staff_names
                              ? item.staff_names
                                  .split(", ")
                                  .map((name, idx) => (
                                    <span
                                      key={idx}
                                      className="badge bg-light text-dark border"
                                    >
                                      {name}
                                    </span>
                                  ))
                              : "N/A"}
                          </div>
                        </div> */}

                        {/* Expand / Collapse Arrow */}
                        <div className="col-12 d-flex justify-content-end m-0">
                          <i
                            className={`fa-solid ${
                              expandedTasks[item.id]
                                ? "fa-chevron-up"
                                : "fa-chevron-down"
                            }`}
                            onClick={() =>
                              setExpandedTasks((prev) => ({
                                ...prev,
                                [item.id]: !prev[item.id],
                              }))
                            }
                            style={{
                              cursor: "pointer",
                              fontSize: 13,
                              color: "#1B2850",
                              // padding: "4px 6px",
                            }}
                            title={
                              expandedTasks[item.id] ? "Show less" : "Show more"
                            }
                          />
                        </div>

                        {/* Expandable Details */}
                        {expandedTasks[item.id] && (
                          <div className="row g-2 m-0 ">
                            {/* Priority */}
                            <div className="col-4">
                              <small className="text-muted d-block">
                                Priority :{" "}
                                {(() => {
                                  switch (item.priority) {
                                    case 1:
                                      return (
                                        <span className="badge bg-outline-warning">
                                          Urgent
                                        </span>
                                      );
                                    case 2:
                                      return (
                                        <span className="badge bg-outline-info">
                                          High
                                        </span>
                                      );
                                    case 3:
                                      return (
                                        <span className="badge bg-outline-success">
                                          Low
                                        </span>
                                      );
                                    default:
                                      return (
                                        <span className="badge bg-outline-dark">
                                          Unknown
                                        </span>
                                      );
                                  }
                                })()}
                              </small>
                            </div>

                            {/* Status */}
                            <div className="col-4">
                              <small className="text-muted d-block">
                                Status :{" "}
                                {(() => {
                                  switch (item.statusId) {
                                    case 1:
                                      return (
                                        <span className="badge bg-outline-danger">
                                          Not Started
                                        </span>
                                      );
                                    case 2:
                                      return (
                                        <span className="badge bg-outline-info">
                                          In Progress
                                        </span>
                                      );
                                    case 3:
                                      return (
                                        <span className="badge bg-outline-warning">
                                          Awaiting Feedback
                                        </span>
                                      );
                                    case 4:
                                      return (
                                        <span className="badge bg-outline-secondary">
                                          Testing
                                        </span>
                                      );
                                    case 5:
                                      return (
                                        <span className="badge bg-outline-success">
                                          Complete
                                        </span>
                                      );
                                    default:
                                      return (
                                        <span className="badge bg-outline-dark">
                                          Unknown
                                        </span>
                                      );
                                  }
                                })()}
                              </small>
                            </div>

                            <div className="col-4 text-end">
                              <span className="badge bg-outline-success">
                                {item.rel_type}
                              </span>
                            </div>

                            {/* Description */}
                            <div className="col-12">
                              <p
                                className=""
                                style={{
                                  fontSize: 13,
                                  overflowWrap: "anywhere",
                                }}
                              >
                                <i className="fa-solid fa-file me-1 text-secondary"></i>
                                {item.description || "No description available"}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        )}

        <div className="mt-3">
          <Pagination
            itemsPerPage={itemsPerPage}
            totalItems={filteredItems.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        </div>
      </div>

      <UploadTasksByExcel />
      <Footer></Footer>
    </Base>
  );
};

export default Tasks;
